// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"63":"user-agreement","963":"privacy-policy"}[chunkId] + "." + {"63":"5ac4ea19","963":"e0eca098"}[chunkId] + ".js";
};